// YouTube SlideshowVideo patch - fixes broken evt.target.h.id in modern YouTube IFrame API
// This patches getVideoOptions() to use a robust method of resolving the player ID
// Apply after theme.js loads

(function() {
  // Wait for theme.SlideshowVideo to exist
  function patchSlideshowVideo() {
    if (!window.theme || !window.theme.SlideshowVideo) {
      setTimeout(patchSlideshowVideo, 100);
      return;
    }

    // The original getVideoOptions used evt.target.h.id which is an internal
    // YouTube API property that breaks in modern YT API versions.
    // We patch the onYouTubeIframeAPIReady callback to wrap player creation
    // so we can intercept the player ID reliably.

    var originalLoadVideos = window.theme.SlideshowVideo.loadVideos;

    // Override YT.Player creation to store player ID on the player object
    window.theme.SlideshowVideo.loadVideos = function() {
      // Store a reference to original YT.Player
      if (window.YT && window.YT.Player) {
        var OriginalYTPlayer = window.YT.Player;
        window.YT.Player = function(id, config) {
          var player = new OriginalYTPlayer(id, config);
          // Store the id so we can retrieve it in event callbacks
          player._slideshowId = id;
          return player;
        };
        // Restore prototype chain
        window.YT.Player.prototype = OriginalYTPlayer.prototype;
      }
      originalLoadVideos.call(this);
    };
  }

  // Patch onYouTubeIframeAPIReady to wrap around the existing one
  var _originalOnYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function() {
    // Patch YT.Player event target id resolution before loading videos
    if (window.YT && window.YT.Player) {
      var OriginalYTPlayer = window.YT.Player;
      window.YT.Player = function(elementId, config) {
        if (config && config.events) {
          var origOnReady = config.events.onReady;
          var origOnStateChange = config.events.onStateChange;

          config.events.onReady = function(evt) {
            // Attach element id to event target for reliable resolution
            if (evt.target) {
              evt.target._slideshowPlayerId = elementId;
            }
            if (origOnReady) origOnReady(evt);
          };

          config.events.onStateChange = function(evt) {
            // Ensure _slideshowPlayerId is propagated via state change events
            if (evt.target && !evt.target._slideshowPlayerId) {
              evt.target._slideshowPlayerId = elementId;
            }
            if (origOnStateChange) origOnStateChange(evt);
          };
        }
        return new OriginalYTPlayer(elementId, config);
      };
    }

    if (_originalOnYouTubeIframeAPIReady) {
      _originalOnYouTubeIframeAPIReady();
    }
  };

  // Also patch getVideoOptions if theme.SlideshowVideo already exposes it
  // by overriding the internal videos resolution via MutationObserver on iframes
  document.addEventListener('DOMContentLoaded', function() {
    // Watch for YouTube iframes being inserted and tag them
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.tagName === 'IFRAME' && node.src && node.src.indexOf('youtube.com') > -1) {
            // The parent div id is the player id
            var parentId = node.parentElement && node.parentElement.id;
            if (parentId) {
              node.setAttribute('data-slideshow-player-id', parentId);
            }
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
